export default "__VITE_ASSET__xrXKbNSd__"